import React from 'react';
import { StatsigFeatureFlagProvider } from './StatsigFeatureFlagProvider';
import { ConfigFeatureFlagProvider } from './ConfigFeatureFlagProvider';

/**
 * Top-level feature-flag provider. Mount inside `AuthProvider`.
 *
 * Selects the backend at build time: GovCloud builds set
 * `VITE_FEATURE_FLAG_PROVIDER=config` to read gates from the control plane
 * (`/api/v1/feature-flags`) with no Statsig egress; every other build uses the
 * Statsig client SDK as before.
 */
export const FeatureFlagProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const provider = import.meta.env.VITE_FEATURE_FLAG_PROVIDER || 'statsig';
  if (provider === 'config') {
    return <ConfigFeatureFlagProvider>{children}</ConfigFeatureFlagProvider>;
  }
  if (provider === 'statsig') {
    return <StatsigFeatureFlagProvider>{children}</StatsigFeatureFlagProvider>;
  }
  throw new Error(
    `Invalid VITE_FEATURE_FLAG_PROVIDER "${provider}". Expected "config" or "statsig". ` +
      'Refusing to fall back to Statsig to avoid unintended commercial egress.'
  );
};
